import styled from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide-v20';

import { StyledBasicRowWrapper } from '@styles/generalStyles';

export const StyledFinalPriceRow = styled(StyledBasicRowWrapper)`
  display: flex;
  padding-right: 0.75rem;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.color.background.disabled};

  @media (min-width: ${breakpoints.md}) {
    justify-content: flex-end;
  }
`;

export const ContentStyled = styled.div`
  line-height: 1.5rem;
  margin-right: 0.75rem;
`;
